skrilla.directive('userContests',function() {
    return {
        templateUrl: 'directives/userContests/userContests.html',
        scope: {
            userId: "="
        },
        controller: function($scope, searchService, srefService, paginationService, queryService){
            $scope.key = "userContestEntries";

            $scope.reset = function () {
                $scope.query = {
                    limit: 20,
                    userId: $scope.userId,
                    statuses: {
                        "LIVE": true,
                        "ELIMINATED": true,
                        "WON": true,
                        "PLACED": true,
                        "LOST": true,
                        "CANCELLED": true,
                    }
                };
            };
            $scope.reset();

            $scope.search = function () {
                paginationService.resetPage($scope.key);
                paginationService.pageQuery(getContests, $scope.key);
            }

            var getContests = function () {
                return searchService.get("pickems/contests/entries" + queryService.getQueryString($scope.query, $scope.key)).then(function (response) {
                    $scope.entries = response.data.result;
                    paginationService.setPage($scope.key, paginationService.buildPage(response));
                });
            }

            $scope.route = function(entry){
                var data = {id: entry.contestId, userId: $scope.userId};
                var path = "";
                switch (entry.contestType){
                    case "csgo-daily":
                        path = "csgoContestDetails";
                        break;
                    case "lol-daily":
                        path = "lolContestDetails";
                        break;
                }
                srefService.go(path, data);
            }

        }
    };
});
